import { render, staticRenderFns } from "./Airline.vue?vue&type=template&id=b364cec8&scoped=true&"
import script from "./Airline.vue?vue&type=script&lang=js&"
export * from "./Airline.vue?vue&type=script&lang=js&"
import style0 from "./Airline.vue?vue&type=style&index=0&id=b364cec8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b364cec8",
  null
  
)

export default component.exports